import { SingleTableBoxScene } from "@/shared/components/ui";
import { Tab, Tabs } from "@mui/material";
import { a11yProps, texto, useCheckPermissions } from "@/shared";
import { useState } from "react";
import { CustomTabPanel } from "../..";
import SupervicionVentaSolicitudPage from "./supervicion-venta-solicitud/SupervicionVentaSolicitudPage";
import SupervicionVentaAprobadoPage from "./supervicion-venta-aprobado/SupervicionVentaAprobadoPage";
import SupervicionVentaRechazadoPage from "./supervicion-venta-rechazado/SupervicionVentaRechazadoPage";
import { PermissionsEnum } from "@/auth/interfaces";

const SupervicionVentaPage = () => {

  useCheckPermissions(PermissionsEnum.api_view_solicituddesbloqueo);

  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene title="Solicitud Línea de Venta">

      <Tabs
        value={valueTab}
        onChange={(_event: React.SyntheticEvent, newValue: number) => {
          setValueTab(newValue);
        }}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        aria-label="scrollable force tabs preventa"
      >
        <Tab label={texto.solicitud} {...a11yProps(0)} />
        <Tab label={texto.aprobado} {...a11yProps(1)} />
        <Tab label={texto.rechazadas} {...a11yProps(2)} />
      </Tabs>

      <CustomTabPanel index={valueTab} value={0}>
        <SupervicionVentaSolicitudPage />
      </CustomTabPanel>
      <CustomTabPanel index={valueTab} value={1}>
        <SupervicionVentaAprobadoPage />
      </CustomTabPanel>
      <CustomTabPanel index={valueTab} value={2}>
        <SupervicionVentaRechazadoPage />
      </CustomTabPanel>
      {/* <CustomTabPanel index={valueTab} value={3}>
          <SupervicionOtpPage />
        </CustomTabPanel> */}

    </SingleTableBoxScene>

  );
}

export default SupervicionVentaPage